import { getListPickerConfigurationOption } from './listPickerConfiguration';
import { resolveListPickerTranslationKey } from './listPickerTranslationKeyResolver';

export function ListPickerAnswerViewConstructor(services, callbacks, context, siteTypeConfig) {
  let joint = services.joint;
  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: true,
    isElementDeletable: true,
    editElementModalController: 'editListPickerAnswerController',
    editElementModalTemplate: require('./editListPickerAnswer.modal.html'),
    /**
     * Allows to disable the trash icon.
     * @example for whatsapp it is not possible to remove the last section because at least one is needed.
     */
    disableRemove: function () {
      const boxView = this._getBoxView();
      const answersMin = this.getConfigurationOption('min-answer');
      return answersMin && boxView.numberOfAnswers === answersMin;
    },

    angularTemplate: `
    <div layout="row">
        <div class="alc-ellipsis"> 
        {{elementData.title || elementView.resolveTranslationKey('answer_title_placeholder') | translate}}
        </div>
    </div>
`,
    resolveTranslationKey: function (key) {
      return resolveListPickerTranslationKey(this.getParentType(), key);
    },
    getConfigurationOption: function (key) {
      return getListPickerConfigurationOption(this.getParentType(), key);
    },

    /**
     * Overriden from ElementView because we need to calculate answers we can delete.
     */
    removeElement: function () {
      const boxView = this._getBoxView();
      if (!boxView.numberOfAnswers || boxView.numberOfAnswers > 1) {
        boxView.numberOfAnswers--;
        this.model.remove();
        boxView.resizeBox();
      }
    },

    _getBoxView: function () {
      const parent = this.model.getAncestors()[0];
      return this.paper.findViewByModel(parent);
    },
  });
}